import MUIListItemText from "@mui/material/ListItemText";

export const ListItemText = MUIListItemText;

export default ListItemText;
